module.exports = __webpack_public_path__ + "img/frame-data-s.6ab3ff04.png";